// extracted by mini-css-extract-plugin
export default {"wrapper":"customer-form_wrapper__4BMQK","title":"customer-form_title__qu8kw","cursorDisabled":"customer-form_cursorDisabled__K62u1"};